// 02.9-shared-widgets.md paso b (§5) -- extraido de CommentArea.jsx. Antes se reconstruia esta
// tabla (con sus 6 `.forEach`) en CADA render del componente; al vivir a nivel de modulo se
// construye una sola vez, al importar.
export const KEYWORDS = {
    'urgente': 'Prioridad Alta',
    'bug': 'Bug Report',
    'revisar': 'Review Needed'
};

// Add Meeting Detection Keywords
const meetingTerms = [
    'reunión', 'reunirnos', 'juntarnos', 'vernos', 'tenemos que vernos',
    'agendar', 'agendar cita', 'coordinar', 'coordinar llamada', 'platicar',
    'llamada', 'llamada rápida', 'cita', 'meet', 'meeting', 'schedule',
    'call', 'sync', 'sinc', 'sink'
];
meetingTerms.forEach(term => {
    KEYWORDS[term] = 'Reunión 📅';
});

// Add Reminder Detection Keywords
const reminderTerms = [
    'recordatorio', 'recordar', 'recuérdame', 'recuerdame', 'reminder',
    'remind', 'remind me', 'alerta', 'alert', 'alarm', 'alarma', 'avisar',
    'avísame', 'avisame', 'notificar', 'notifícame', 'notificame', 'notificación',
    'notification', 'ping', 'aviso', 'acordarme', 'acuérdame', 'acuerdame',
    'no se me olvide', 'que no se me pase', 'más tarde', 'mas tarde', 'luego me dices',
    'después recuérdame', 'despues recuerdame', 'mañana recuérdame', 'manana recuerdame',
    'pon alarma', 'pon un recordatorio', 'lo vemos después', 'lo vemos despues',
    'lo vemos luego', 'después hablamos', 'despues hablamos', 'lo vemos mañana',
    'lo vemos manana', 'la siguiente semana', 'próxima semana', 'la proxima semana'
];
reminderTerms.forEach(term => {
    KEYWORDS[term] = 'Recordatorio ⏰';
});

// Add Documentation Detection Keywords
const docTerms = [
    'documentación', 'documentacion', 'docs', 'doc', 'manual', 'manuales', 'guía', 'guia',
    'guías', 'guias', 'tutorial', 'tutoriales', 'how to', 'how-to', 'instrucciones',
    'instructivo', 'paso a paso', 'referencia', 'referencias', 'help', 'ayuda', 'soporte',
    'knowledge base', 'base de conocimiento', 'wiki', 'faq', 'faqs', 'preguntas frecuentes',
    'readme', 'read me', 'setup', 'configuración', 'configuracion', 'onboarding',
    'getting started', 'ejemplo', 'ejemplos'
];
docTerms.forEach(term => {
    KEYWORDS[term] = 'Documentación 📄';
});

// Add Presentation Detection Keywords
const presoTerms = [
    'presentación', 'presentacion', 'presentaciones', 'pitch', 'pitch deck', 'deck',
    'slide', 'slides', 'slide deck', 'demo', 'demostración', 'demostracion', 'propuesta',
    'propuesta comercial', 'presentación comercial', 'sales deck', 'investor deck',
    'one pager', 'one-pager', 'brochure', 'folleto', 'catálogo', 'catalogo', 'material comercial',
    'material de ventas', 'kit comercial', 'media kit', 'dossier', 'overview', 'intro',
    'introducción', 'introduccion', 'resumen ejecutivo', 'executive summary', 'pdf',
    'presentación para cliente', 'documento para cliente', 'archivo para cliente'
];
presoTerms.forEach(term => {
    KEYWORDS[term] = 'Presentaciones 📐';
});

// Add Survey Detection Keywords
const surveyTerms = [
    'encuesta', 'encuestas', 'survey', 'poll', 'votación', 'votaciones', 'votar', 'voto',
    'vote', 'voting', 'ballot', 'pregunta', 'preguntas', 'preguntar', 'preguntale',
    'pregúntale', 'preguntale al equipo', 'pregunta al equipo', 'preguntar al equipo',
    'opinión', 'opiniones', 'opinan', 'opinen', 'qué opinan', 'que opinan', 'feedback',
    'retroalimentación', 'decide', 'deciden', 'decidir', 'decisión', 'decidir juntos',
    'consenso', 'majority', 'mayoría', 'quien', 'quién', 'quién prefiere', 'quien prefiere',
    'prefiere', 'prefieren', 'prefieres', 'elijan', 'elijanlo', 'elegir', 'elección',
    'elecciones', 'escoger', 'escogemos', 'pick', 'choose'
];
surveyTerms.forEach(term => {
    KEYWORDS[term] = 'Encuesta 🙋';
});

// Add Workflow Detection Keywords
const flowTerms = [
    'flujo', 'workflow', 'flujo de trabajo', 'proceso', 'procesos', 'pasos', 'paso a paso',
    'pasos a seguir', 'siguiente paso', 'siguientes pasos', 'secuencia', 'orden',
    'orden de pasos', 'pipeline', 'ruta', 'ruta de trabajo', 'guía de proceso',
    'metodología', 'método', 'procedimiento', 'procedimientos', 'lista de pasos',
    'flowchart', 'diagrama', 'diagrama de flujo', 'cómo sigue', 'que sigue', 'qué sigue',
    'next steps', 'next step'
];
flowTerms.forEach(term => {
    KEYWORDS[term] = 'Flujo 🗡️';
});
